import React from 'react';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { Button, Space, Typography } from 'antd';
import { HolderOutlined, PlusOutlined } from '@ant-design/icons';
import zoneStore from '../../Store';
import queueStore from '../../Store/queueStore';
import selectionStore, { selectButton } from '../../Store/selectionStore';
import {
  createButton, getScreens, reorderButtons, replaceScreen, saveZone,
} from '../../../utils/zoneMutations';
import { describeButtonTarget, isBrokenTarget } from '../../../utils/flowAnalysis';
import { attachIcon } from '../../../utils/buttonIcon';
import ButtonRow from '../ButtonRow';

function ButtonList({ screen }) {
  const screens = zoneStore.useState((s) => s.config.screens);
  const queues = queueStore.useState((s) => s.queue) || [];
  const activeButtonId = selectionStore.useState((s) => s.buttonId);

  const addButton = async () => {
    const button = createButton(screen);
    const updated = { ...screen, buttons: [...screen.buttons, button] };

    const ok = await saveZone(replaceScreen(getScreens(), updated), 'Кнопка добавлена');
    if (ok) selectButton(screen.screenId, button.id);
  };

  const onDragEnd = async (result) => {
    if (!result.destination || result.destination.index === result.source.index) return;

    await saveZone(
      reorderButtons(getScreens(), screen.screenId, result.source.index, result.destination.index),
      'Порядок кнопок сохранён',
    );
  };

  return (
    <div>
      <Typography.Text strong>Кнопки экрана</Typography.Text>

      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId={`buttons-${screen.screenId}`}>
          {(provided) => (
            <div ref={provided.innerRef} {...provided.droppableProps} style={{ marginTop: 6 }}>
              {screen.buttons.map((button, index) => {
                const target = describeButtonTarget(button, screens, queues);

                return (
                  <Draggable draggableId={button.id} index={index} key={button.id}>
                    {(dragProvided) => (
                      <div
                        ref={dragProvided.innerRef}
                        {...dragProvided.draggableProps}
                        style={{ ...dragProvided.draggableProps.style }}
                      >
                        <ButtonRow
                          name={button.name}
                          targetLabel={target.label}
                          icon={button.icon || null}
                          showIconSlot
                          isBroken={isBrokenTarget(target)}
                          isActive={activeButtonId === button.id}
                          onClick={() => selectButton(screen.screenId, button.id)}
                          onIconDrop={(file) => attachIcon(screen.screenId, button, file)}
                          handle={(
                            <span {...dragProvided.dragHandleProps} style={{ color: '#bfbfbf' }}>
                              <HolderOutlined />
                            </span>
                          )}
                        />
                      </div>
                    )}
                  </Draggable>
                );
              })}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>

      <Space style={{ marginTop: 4 }}>
        <Button icon={<PlusOutlined />} onClick={addButton}>Кнопка</Button>
      </Space>
    </div>
  );
}

export default ButtonList;
